const reviews = [
  {
    name: "김○○ 님",
    tag: "교통사고 손해액",
    text: "교통사고 후 보험사에서 제시한 손해액이 너무 적어 답답했는데, 다다손해사정에서 객관적인 산정으로 3배 이상 인상되어 마무리했습니다. 정말 감사합니다.",
    place: "경기 · 40대",
  },
  {
    name: "박○○ 님",
    tag: "근재보험 보상금",
    text: "업무상재해 인정이 거절되어 포기하려 했는데, 추가 자료 수집과 재검토를 통해 재해 인정과 보상금을 확보할 수 있었습니다. 전문성이 남달랐어요.",
    place: "서울 · 50대",
  },
  {
    name: "이○○ 님",
    tag: "누수사고 배상",
    text: "아파트 누수로 피해를 봤는데 배상금 산정이 부실하게 되어 있었어요. 다다손해사정에서 재산정을 도와주셔서 정당한 금액을 받을 수 있었습니다.",
    place: "인천 · 60대",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-secondary-100 py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="text-primary-600 text-xs tracking-[0.32em] font-semibold mb-4">
            CLIENT VOICES
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            <span className="md:inline block">의뢰인이 남긴</span>
            <span className="md:inline block text-primary-600">진짜 이야기</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div
              key={r.name + i}
              className="bg-background-50 rounded-lg p-8 border border-background-200/70 flex flex-col"
            >
              <div className="flex items-center gap-1 text-primary-500">
                {Array.from({ length: 5 }).map((_, k) => (
                  <i key={k} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <i className="ri-double-quotes-l text-4xl text-primary-300 mt-4"></i>
              <p className="mt-2 text-foreground-800 text-sm leading-relaxed flex-1">
                {r.text}
              </p>
              <div className="mt-6 pt-5 border-t border-background-200 flex items-center justify-between">
                <div>
                  <div className="font-semibold text-foreground-950 text-sm">
                    {r.name}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{r.place}</div>
                </div>
                <span className="text-xs font-semibold text-primary-700 bg-primary-100 px-3 py-1 rounded-full whitespace-nowrap">
                  {r.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}